import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import store from "../../../store/store";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import AddBrand from "../AddBrand";

const InitMiddlewareAddBrand: React.FC<any> = (props) => {
  const { addBrandRes = {}, isSuccess } = useSelector(
    (state: any) => state.rootReducer?.brand ?? {}
  );

  // console.log("addBrandRes", addBrandRes);
  const navigate = useNavigate();

  useEffect(() => {
    const data: any = [
      {
        label: "Brands",
        link: `/brands`,
      },
      {
        label: "Add new brand",
        link: ``,
      },
    ];
    store.dispatch(addBreadcrumb(data));
  }, []);

  useEffect(() => {
    if (isSuccess && addBrandRes?.success === true) {
      navigate("/brands");
    }
  }, [isSuccess, addBrandRes, navigate]);

  // if (isSuccess && addBrandRes && addBrandRes?.success === true) {
  //   navigate("/brands");
  //   return null;
  // } else {
  //   return <AddBrand {...props} />;
  // }
  return <AddBrand {...props} />;
};

export default InitMiddlewareAddBrand;
